import React from "react";
import { Grid } from "semantic-ui-react";
import PageHeader from "../SiteLayout/PageHeader";
import AdminAccordion from "./AdminAccordion";
 
const MainPage = () => (
  <Grid>
    <Grid.Row>
      <Grid.Column>
        <PageHeader Name="Admin Portal" Icon="settings" Description="Admin control over site!" />
      </Grid.Column>
    </Grid.Row>
    <Grid.Row>
      <Grid.Column>
        <AdminAccordion />
      </Grid.Column>
    </Grid.Row>
  </Grid>
)
export default MainPage;